'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input, Icon, Tooltip } from 'dumb';

import { TableList, TableListCell, TableListRow } from 'dumb/tables/table-list';

// phrases/ constants
import phrases from './../../../waitingTimeScheduleEntries.phrases';

class WaitingTimeScheduleEntriesBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		// get value from event
		const value = e.target?.value;

		// edits the row in the store
		this.props.editBatchListItem({
			...row,
			[type]: value,
		});
	}

	render() {
		const { batchList, addBatchListItemRow } = this.props;

		return (
			<>
				<TableList>
					<thead>
						<tr>
							<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
							<th>{phrases.MODAL_BATCH_STEP_PRODUCTS}</th>
							<th>{phrases.MODAL_BATCH_STEP_MINUTES}</th>

							<th />
						</tr>
					</thead>
					<tbody>
						{batchList.map((entry, i) => {
							const editButtonDisabled = batchList.length === 1;

							return (
								<TableListRow key={entry.identifier}>
									<TableListCell>{i + 1}</TableListCell>

									<TableListCell>
										<Input
											id="products"
											type="number"
											placeholder={
												phrases.MODAL_BATCH_STEP_PRODUCTS_PLACEHOLDER
											}
											value={entry.products || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'products')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="minutes"
											type="number"
											placeholder={phrases.MODAL_BATCH_STEP_MINUTES_PLACEHOLDER}
											value={entry.minutes || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'minutes')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Button
											type="negative"
											size="tiny"
											disabled={editButtonDisabled}
											onClick={() => this._onRemoveEntry(entry.identifier)}>
											<Icon name="delete" />
										</Button>
									</TableListCell>
								</TableListRow>
							);
						})}
					</tbody>
				</TableList>
				<div className="waiting-time-schedule-entries__add-new-row">
					<Tooltip
						text={phrases.MODAL_BATCH_STEP_LIST_TOOLTIP}
						zIndex="600"
						renderData={(ref, onMouseEnter, onMouseLeave) => (
							<Button
								type="secondary"
								onClick={addBatchListItemRow}
								onMouseEnter={onMouseEnter}
								onMouseLeave={onMouseLeave}
								refProp={ref}>
								<Icon name="add" />
							</Button>
						)}
					/>
				</div>
			</>
		);
	}
}

WaitingTimeScheduleEntriesBatchStepList.propTypes = {
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
};

export default WaitingTimeScheduleEntriesBatchStepList;
